import { useEffect } from 'react';
import { Newspaper, X } from '@phosphor-icons/react';
import { useAppStore } from '@/store/appStore';
import { FeedPanel } from './FeedPanel';

// Modal de Actividad del equipo, accesible desde la campana del TopBar en
// cualquier pantalla. Reusa FeedPanel (el mismo cuerpo de la FeedPage).
export function ActividadModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  const selectTask = useAppStore((s) => s.selectTask);

  useEffect(() => {
    if (!open) return;
    function onKey(e: KeyboardEvent) { if (e.key === 'Escape') onClose(); }
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 bg-black/40 flex items-start justify-center p-4 sm:pt-12"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl w-full max-w-2xl h-[80vh] overflow-hidden flex flex-col shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-3 border-b border-stone-200">
          <h2 className="text-base font-semibold text-stone-900 flex items-center gap-2">
            <Newspaper size={18} weight="bold" />
            Actividad del equipo
          </h2>
          <button onClick={onClose} className="p-1 hover:bg-stone-100 rounded" aria-label="Cerrar">
            <X size={18} weight="bold" />
          </button>
        </div>
        <div className="flex-1 overflow-hidden">
          {/* Al abrir una tarea desde el feed, cerramos el modal de Actividad
              para que el TaskModal quede visible sin superposición. */}
          <FeedPanel onTaskClick={(id) => { onClose(); selectTask(id); }} />
        </div>
      </div>
    </div>
  );
}
